import { gql } from '@efficiently/client-core-graphql-models';

export const RUN_PLAN_TO_SCHEDULES = gql(`
	mutation runPlanToSchedules($projectId: String!, $versionId: String!) {
		runPlanToSchedules(projectId: $projectId, versionId: $versionId)
	}
`);
